import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { AdministratorService } from '../../../services/administrator.service';
import { UnitsOfMeasureGridResponse } from '../../../model/administration.model';
import { gridPageRequest } from '../../../model/common/common.model';
import { SharedModule } from '../../../shared/shared.module';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-uomlookup',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './uomlookup.component.html',
  styleUrl: './uomlookup.component.scss'
})
export class UOMLookupComponent {

  constructor(private administratorService: AdministratorService, public ref: DynamicDialogRef, private messageService: MessageService) { }


  searchText: any;
  productCode: any;

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }


  result: UnitsOfMeasureGridResponse = {
    unitsofMeasures: [],
    totalRecords: 0
  }

  ngOnInit(): void {
    this.getUnitsOfMeasure();
  }

  getUnitsOfMeasure() {
    this.administratorService.getAllUnitsOfMeasure(this.pageRequest).subscribe({
      next: data => {
        this.result = data as UnitsOfMeasureGridResponse;
      },
      error: error => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error while fetching uom.' });
      }
    });
  }


  onRowSelect(event: any) {
    this.ref.close(event?.data);
  }

}
